import PageContainer from "components/PageContainer";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { Route, Routes, useLocation, useSearchParams } from "react-router-dom";
import AuditsCalendar from "./components/AuditsCalendar";
import { useAuth } from "contexts/auth.context";
import AccessDenied from "components/AccessDenied";

export default function CalendarPage() {
  const [route, setRoute] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setRoute(null);
  }, [location]);

  const { checkPermission } = useAuth();

  if (
    Object.keys(checkPermission("audit")).filter(
      (key) => checkPermission("audit")[key]
    ).length == 0
  ) {
    return <AccessDenied type="page" />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar customRoute={route} />

      <PageContainer>
        <Routes>
          <Route index element={<AuditsCalendar />} />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}
